import React from "react";
import { AppContext } from "../../contexts/AppContext";
import AuthContext from "../../contexts/AuthContext";
import api from "../../actions/common";

export const useGenres = () => {
  const { genres, genresDispatch } = React.useContext(AppContext);
  const [loading, setLoading] = React.useState(false);
  const { token } = React.useContext(AuthContext);
  React.useEffect(() => {
    if (genres.length === 0) {
      getGenres(genresDispatch, token, setLoading);
    }
  }, []);

  return { genres, loading };
};

const getGenres = async (dispatch, token, setLoading) => {
  // api;
  const resp = await api.get("/genre", token, {}, setLoading);

  if (resp.success) {
    dispatch({
      type: "set",
      payload: resp.genres,
    });
  } else {
    console.log("Failed to get Genres");
  }
};
